// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUsers as RawLucideUsers } from "lucide-react";
export const LucideUsers = /* @__PURE__ */ createIcon(RawLucideUsers, "LucideUsers", 2);
